import { Language } from "./Language";

export const COUNTRIES_LABEL = [
  {
    code: "en",
    text: "English",
    disabled: false,
  },
  {
    code: "de",
    text: "Deutsch",
    disabled: false,
  },
] as { code: Language; text: string; disabled: boolean }[];
